import apiCalls from '../../utils/apiCalls';

export const BILLS_GET_BEGIN   = 'BILLS_GET_BEGIN';
export const BILLS_GET_SUCCESS = 'BILLS_GET_SUCCESS';
export const BILLS_GET_FAILURE = 'BILLS_GET_FAILURE';
export const BILL_SET_SUCCESS = 'BILL_SET_SUCCESS';
export const BILL_REMOVE_SUCCESS = 'BILL_REMOVE_SUCCESS';

export const billsGetBegin = () => ({
  type: BILLS_GET_BEGIN
});

export const billsGetSuccess = bills => ({
  type: BILLS_GET_SUCCESS,
  payload: { bills }
});

export const billsGetFailure = error => ({
  type: BILLS_GET_FAILURE,
  payload: { error }
});

export const billSetSuccess = bill => ({
  type: BILL_SET_SUCCESS,
  payload: { bill }
});

export const billRemoveSuccess = bill => ({
  type: BILL_REMOVE_SUCCESS,
  payload: { bill }
});

export const setBill = bill => {
  return dispatch => {
    dispatch(billSetSuccess(bill));
  };
};

export const removeBillFromList = bill => {
  return dispatch => {
    dispatch(billRemoveSuccess(bill));
  };
};

export const getBills = params => {
  return dispatch => {
    dispatch(billsGetBegin());
    return apiCalls.getBills(params)
      .then(res => res.data)
      .then(data => {
        dispatch(billsGetSuccess(data.bills));
        return data.bills;
      })
      .catch(error => {
        dispatch(billsGetFailure(error));
        throw error;
      });
  };
};